import { Trans } from '@lingui/macro'

import * as React from 'react'

import { TFUserAgreement } from '~graphql/generated/clientGraphql'
import { Button } from '~ui/components/buttons/Button/Button'
import { Card } from '~ui/components/content/Card/Card'
import { RequiredIndicator } from '~ui/components/formElements/accessories/RequiredIndicator'
import { Box, Grid } from '~ui/components/layout/Box'
import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren & {
  onLabelClick?: () => void
  agreement: TFUserAgreement
}

/**
 * Expandable label & description section of an agreement in the order form,
 * shows the required indicator if the agreement is mandatory.
 */
export const AgreementLabel: React.FC<TProps> = ({ agreement, onLabelClick }) => {
  const [expanded, setExpanded] = React.useState(false)

  const hasDescription = agreement.description.length > 0

  const renderExpandButton = (isExpanding: boolean) => (
    <Button
      top={`-1px`} // visual alignment
      shadow={`none`}
      variant={`ghost`}
      position={`relative`}
      onClick={() => setExpanded(isExpanding)}
      padding={{ left: `extraSmall`, right: `none`, top: `none`, bottom: `none` }}
    >
      <Text as={`span`} fontSize={`s14`} fontStyle={`regularItalic`}>
        {isExpanding ? <Trans>show more</Trans> : <Trans>show less</Trans>}
      </Text>
    </Button>
  )

  return (
    <Grid rowGap={`extraSmall`}>
      <Text>
        <Box as={`span`} cursor={`pointer`} onClick={onLabelClick}>
          {agreement.title}
        </Box>
        {agreement.isMandatory && <RequiredIndicator />}
        {!expanded && hasDescription && renderExpandButton(true)}
      </Text>
      {expanded && (
        <Card bgColor={`bgColors.card`} padding={`small`}>
          <Text fontSize={`s14`}>
            {/* the description can contain anchors, bold text etc */}
            <span dangerouslySetInnerHTML={{ __html: agreement.description }} />
            {renderExpandButton(false)}
          </Text>
        </Card>
      )}
    </Grid>
  )
}
